/* @flow */
import React from 'react';
// $FlowIgnore
import moment from 'moment';

import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import TransactionsLink from 'components/Links/TransactionsLink';
import TransactionIcon from 'components/icons/TransactionIcon';

export default function TransactionList({
  children, style, isFetching
}: Object): React.Element {
  return (
    <Column style={{
      borderLeft: '1px',
      borderRight: '1px',
      borderBottom: '1px',
      borderTop: '0',
      borderStyle: 'solid',
      borderColor: '#e5e5e5',
      ...style}}>
      {isFetching && (
        <Row style={{alignItems: 'center', padding: '1rem', borderTop: '1px solid #e5e5e5'}}>
          <TransactionIcon style={{ marginRight: '1rem', fontSize: '1.5rem' }} />
          Loading Transactions...
        </Row>
      )}
      {!isFetching && !(children || []).length && (
        <Row style={{alignItems: 'center', padding: '1rem', borderTop: '1px solid #e5e5e5'}}>
          <TransactionIcon style={{ marginRight: '1rem', fontSize: '1.5rem' }} />
          No Transactions found.
        </Row>
      )}
      {(children || []).map(c => (
        <Row style={{alignItems: 'center', padding: '0.25rem 1rem', borderTop: '1px solid #e5e5e5'}} key={c.id}>
          <TransactionIcon type={c.type} style={{ marginRight: '1rem', fontSize: '1.5rem' }} />
          <Column style={{flex: 1}}>
            <Row style={{justifyContent: 'space-between'}}>
            <TransactionsLink projectId={c.project_id} query={{id: c.id, did: c.id}}>#{c.id}</TransactionsLink>
            <em>{moment(c.created_datetime).format('ll')}</em>
            </Row>
            <Row style={{justifyContent: 'space-between'}}>
              <Row style={{textTransform: 'uppercase', color: '#666'}}>{c.type}</Row>
              <em>{c.project_id}</em>
            </Row>
          </Column>
        </Row>
      ))}
    </Column>
  );
}
